import { composeValidators } from '@reliance/forms-js/lib/validation';
import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import Row from 'react-bootstrap/Row';
import { Field } from 'react-final-form';

type SelectProps = {
  name: string
  label: string
  id?: string
  placeholder?: string
  validationRules?: any[]
  helperText?: string
  disabled?: boolean
  children: React.ReactNode
}

type InlineSelectProps = SelectProps & {
  labelCols: number
}

export const Select: React.FC<SelectProps> = (props) =>
  <Field
    name={props.name}
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) => (
      <FormGroup>
        <label>{props.label}</label>

        <Field
          id={props.id}
          className={`form-control ${meta.touched && meta.error ? 'has-error' : ''}`}
          component="select"
          disabled={meta.submitting || props.disabled}
          {...input}>
          {props.children}
        </Field>
        {meta.error && meta.touched ? (
          <span className="help-block has-error">{meta.error}</span>
        ) : props.helperText ? (
          <span className="help-block text-muted">{props.helperText}</span>
        ) : null}
      </FormGroup>
    )}
  </Field>

export const InlineSelect: React.FC<InlineSelectProps> = (props) =>
  <Field
    name={props.name}
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) => (
      <FormGroup as={Row}>
        <Form.Label column sm={props.labelCols}>{props.label}</Form.Label>

        <Col>
          <Field
            id={props.id}
            className={`form-control ${meta.touched && meta.error ? 'has-error' : ''}`}
            component="select"
            disabled={meta.submitting || props.disabled}
            {...input}>
            {props.children}
          </Field>
          {meta.error && meta.touched ? (
            <span className="help-block has-error">{meta.error}</span>
          ) : props.helperText ? (
            <span className="help-block text-muted">{props.helperText}</span>
          ) : null}
        </Col>
      </FormGroup>
    )}
  </Field>